<template>
    <gofix-card class="cardTable chartOfAccount searchEmail" fullContent>
        <gofix-default-table
                :column-width-setting="columnWidthSetting"
                :settings="tableConfig"
                :table-items="tableItems"
                @load-items="getTableData"
                @get-column-settings="getColumnSettings"
                @change-selected="changeSelectedTable"
                ref="gofixTable">
                <template slot="gofix_table:s3_eml_url" slot-scope="row">
                    <div class="dataControls">
                        <a title="Download" v-b-tooltip.hover
                        class="control-item-link cursor-pointer">
                            <img src="img/download.png" alt="Download" @click="downloadFile(row.item)">
                        </a>
                    </div>
                </template>
        </gofix-default-table>
    </gofix-card>
</template>

<script>
    import { mapGetters } from "vuex";
    import { filters } from '@/_filterVar.js'

    export default {
        name: "email-search",
        props: {
            nameTable: {
                type: String,
                default: "email-integration-search"
            },
        },
        components: {
        },
        data() {
            let filter = JSON.parse(JSON.stringify(filters['email_search']));
            return {
                columnWidthSetting:
                {
                    leftWidth:5,
                    rightWidth:7
                },
                columnSettings: [],
                tableConfig:{
                    name: this.nameTable,
                    controls:{
                        create: false,
                        delete: false,
                        tableExport: false,
                        tableImport: false,
                    },
                    filter: filter,
                    buildFilter: true,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: true,
                    sortColumn: "id",
                    sortDirection: "asc",
                    fields: [{
                                key: "actions",
                                label: "",
                                thStyle: "width:65px"
                            }, {
                                key: "subject",
                                label: "Subject",
                                thStyle: "width:150px",
                                isActive: true,
                                isFilter: true
                            }, {
                                key: "body_preview",
                                label: "Body Preview",
                                thStyle: "width:250px",
                                isActive: true,
                                isFilter: true
                            }
                        ]
                },
                tableItems:[],
                pagesProperties: {
                    isCMS: '1',
                    limit: 100,
                    page: 1,
                    totalPage: 0,
                    filter: JSON.parse(JSON.stringify(filters['email_search']))
                },
                classInput: "width-175",
                innerWidth: 0,
            }
        },
        watch: {
        },
        computed: {
            ...mapGetters({
                ClientContractID: "ContractController/ClientContractID"
            })
        },
        mounted() {
            // window.addEventListener('resize', this.handleResize);
            // this.handleResize();
        },
        created() {
            
        },
        destroyed() {
            //window.removeEventListener('resize', this.handleResize);
        },
        methods: {
            changeSelectedTable(val) {
            },
            handleResize() {
                this.innerWidth = window.innerWidth;
                this.classInput = "width-175";
                if (window.innerWidth < 1500) {
                    this.classInput = "width-99"
                }
            },
            getColumnSettings(settings){
                this.columnSettings = settings;
            },
            async getTableData(callback){
                const { tableRequest , resolve,reject } = await callback();
                // if(!this.general.contract_id) {
                //     this.tableItems = [];
                //     resolve({
                //         items: [],
                //         total: 0
                //     });
                //     return;
                // }

                tableRequest.filter.mail_box.value = 'inbox';

                await this.$store.dispatch("EmailIntegrationController/getListEmails", tableRequest)
                    .then(response => {
                        this.tableItems = response.data.data.items;
                        this.tableConfig.total = response.data.data.total;
                        resolve(response.data.data);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load the emails", "danger");
                        reject();
                    });
                
            },
            reloadEmails() {
                this.$refs.gofixTable.reloadTableItems();
            },
            async downloadFile(email) {
                let url = email.s3_eml_url;
                let params = {};
                params.url = url;
                params.image_file_name = email.message_id + '.eml';

                 await this.$store.dispatch("FileDownloadController/getFile", params)
                .then(response => {
                })
                .catch(err => {
                    this.$alertNotification("Can not download file", "danger");
                    console.log(err);
                })
        },

        }
    }
</script>
